import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import sentenceSeparator from '../../../utils/sentenceSeparator';
import style from '../../../style/components/profile/emails/BlockedDomainAlert.module.scss';

const BlockedDomainAlert = ({
  attemptsRemaining,
  onContactSupport,
  onTryDifferent,
}) => {
  const { t, i18n } = useTranslation();
  const maxAttempts = 3;
  const currentAttempt = maxAttempts - attemptsRemaining;

  return (
    <div className={style.alertContainer}>
      <div className={style.alertContent}>
        <div className={style.iconContainer}>
          <idme-icon name="alert-octagon" size="small" />
        </div>
        <div className={style.textContainer}>
          <div className={style.messageBlock}>
            <h3 className={style.alertTitle}>
              {t('walletEmails.blockedTitle')}
            </h3>
            <p className={style.alertBody}>
              {t('walletEmails.blockedBody')}
              {sentenceSeparator(i18n.language)}
              <span className={style.attemptCounter}>
                {t('walletEmails.blockedAttempts', {
                  current: currentAttempt,
                  max: maxAttempts,
                })}
              </span>
            </p>
          </div>
          <div className={style.actionGroup}>
            <button
              type="button"
              className={style.tryDifferentButton}
              onClick={onTryDifferent}
            >
              {t('walletEmails.blockedTryDifferent')}
            </button>
            <button
              type="button"
              className={style.contactButton}
              onClick={onContactSupport}
            >
              {t('walletEmails.blockedContactSupport')}
              <idme-icon name="external-link" size="small" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

BlockedDomainAlert.propTypes = {
  attemptsRemaining: PropTypes.number.isRequired,
  onContactSupport: PropTypes.func.isRequired,
  onTryDifferent: PropTypes.func.isRequired,
};

export default memo(BlockedDomainAlert);
